import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { SmallTagRounded } from '@/components/ui/Tag/SmallTagRounded';
import { RFP_ICONS } from '@/utils/constants/rfp/icons';
const colors = {
    no_view: 'orange',
    no_view_request: 'orange',
    offer_consideration: 'lightBlue',
    offer_done: 'darkBlue',
    offer_planning: 'lightOrange',
    offer_refuse: 'gray',
    reject_view_request: 'darkGray',
    view_request: 'blueGray',
};
/**
 * コンサルタントの案件ステータス表示用のコンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalStatusTag = (props) => {
    const { className = '', icons } = props;
    const icon = useMemo(() => RFP_ICONS.find((v) => v.value === icons[0]), [icons]);
    // 一致するアイコンが存在しない場合、何も表示しない
    if (!icon) {
        return null;
    }
    return (_jsx(SmallTagRounded, Object.assign({ className: clsx(className), color: colors[icon.value], isKanjiTopFixed: true, size: 'md' }, { children: icon.label })));
};
export const RfpProfessionalStatusTagColors = colors;
